import React, { createContext, useContext, useEffect, useState } from 'react';
import { maintenanceService } from '../services/maintenanceService';

const MaintenanceContext = createContext({
  maintenanceEnabled: false,
  maintenanceMessage: '',
  estimatedReturn: '',
  loading: true
});

export const useMaintenanceMode = () => useContext(MaintenanceContext);

export const MaintenanceProvider = ({ children }) => {
  const [maintenanceEnabled, setMaintenanceEnabled] = useState(false);
  const [maintenanceMessage, setMaintenanceMessage] = useState('');
  const [estimatedReturn, setEstimatedReturn] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Initial load
    loadMaintenanceStatus();

    // Subscribe to real-time changes
    const channel = maintenanceService?.subscribeToMaintenanceChanges((status) => {
      setMaintenanceEnabled(status?.enabled || false);
      setMaintenanceMessage(status?.message || '');
      setEstimatedReturn(status?.estimatedReturn || '');
    });

    return () => {
      maintenanceService?.unsubscribe(channel);
    };
  }, []);

  const loadMaintenanceStatus = async () => {
    try {
      const status = await maintenanceService?.getMaintenanceStatus();
      setMaintenanceEnabled(status?.enabled || false);
      setMaintenanceMessage(status?.message || '');
      setEstimatedReturn(status?.estimatedReturn || '');
    } catch (err) {
      // Default to not in maintenance if fetch fails
      setMaintenanceEnabled(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <MaintenanceContext.Provider value={{
      maintenanceEnabled,
      maintenanceMessage,
      estimatedReturn,
      loading
    }}>
      {children}
    </MaintenanceContext.Provider>
  );
};

export default MaintenanceContext;
